module.exports = __webpack_public_path__ + "img/volume-off.0052dbd5.svg";